import { navigateTo } from './navigateTo';

export const backToEnsList = () => async (dispatch) => {
  dispatch(navigateTo('ensuranceList'));
  dispatch({ type: 'RESET_TO_ENSLIST' });
};
